import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ContactService } from 'src/app/services/contact.service';
import { RutValidator } from 'ng9-rut';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import { AuthService } from 'src/app/services/auth.service';
import { Contact } from 'src/app/models/contact.model';
import { NotaService } from 'src/app/services/nota.service';
import { Notas } from 'src/app/models/notas.model';
import { Puntaje } from 'src/app/models/puntaje.model';
import { ProcesoMatriculaService } from 'src/app/services/procesomatricula.service';
import { FaseService } from 'src/app/services/fase.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ApiCallResult } from 'src/app/models/apicallresult.model';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators'
@Component({
  selector: 'app-educacion',
  templateUrl: './educacion.component.html',
  styleUrls: ['./educacion.component.css']
})
export class EducacionComponent implements OnInit, OnDestroy {
  // External
  @Output() CursandoCuartoMedio: EventEmitter<boolean> = new EventEmitter();
  @Input() IdProceso: string;
  @Output() Fase: EventEmitter<string> = new EventEmitter();
  @Input() faseActual: string;
  @Input() ultimafase: number;
  EducacionSubcribe: Subscription;
  // Alerts
  progress = false;
  alertError = false;
  alertSucces = false;
  btnEnviar = false;

  habilitaBotones = false;
  cargandoDatos = true;
  cargaDatosContacto = false;
  cargaDatosRegion = false;
  cargaAnhoEgreso = false;
  cargaDatosEstablecimiento = false;
  cargaDatosNotasPsu = false;
  cargaDatosNotas = false;

  searchCtrl: any;
  result_Dependencia: ApiCallResult = new ApiCallResult([])

  PerfilForm: FormGroup;
  validarionsRut: any;
  Nacionalidades: any[];
  //Regiones: any[];
  RegionesColegios: any[];
  Comunas: any[];
  Ciudades: any[];
  Paises: any[];
  Establecimientos: any[];
  Establecimientos2: any[];
  AnhosEgresos: any[];
  AnhoPsu: any[];

  constructor(
    private route: ActivatedRoute,
    private contactservice: ContactService,
    private fb: FormBuilder, rutValidator: RutValidator,
    private mantenedor: MantenedorService,
    private auths: AuthService,
    private notaservice: NotaService,
    private procesoservice: ProcesoMatriculaService,
    public faseService: FaseService,
    private alerts: ToastrService
  ) {
    this.validarionsRut = rutValidator;
    this.PerfilForm = this.fb.group({
      EnsenhazaMediaEextranjero: [false], //OK
      PrimeroMedioExterior: [false], //OK
      SegundoMedioExterior: [false], //OK
      TerceroMedioExterior: [false], //OK
      CuartoMedioExterior: [false], //OK
      CuarsandoCuartoMedio: [false],
      CurseEnsenhanzaModalidad: [false], //OK // NO SE USA
      AnhoEgresoEM: [''], //OK
      RegionEstudio: [''], //OK
      EstablecimientoEducacionl: [''], //OK
      TipoDependencia: [''],
      CursoEM2x1: [false], //OK
      PrimeroMedio2x1: [false], //OK
      SegundoMedio2x1: [false], //OK
      TerceroMedio2x1: [false], //OK
      CuartoMedio2x1: [false], //OK
      DeseaRecibirAsesoria: [false], //OK
      Etnia: [''], //OK
      Pais: [''], //OK
      CertificadoCulminacionEM: [false], //OK
      IdContacto: [''], //OK
      BloqueoFinanciero: [false], //OK
      SerialRut: [''], //OK
      NotaPrimeroMedio: ['', Validators.min(1)],
      NotaSegundoMedio: ['', Validators.min(1)],
      NotaTerceroMedio: ['', Validators.min(1)],
      NotaCuartoMedio: ['', Validators.min(1)],
      PuntajePromedioPsu: ['', []], //OK1
      Ranking: ['', []], //OK1
      AnhoPsu: ['', []], //OK1
      FasePortal: ['2']
    });

    this.route.params.subscribe(params => {
      if (params.id !== '' && params.id !== undefined) {
        this.IdProceso = `${params.id}`;
      }
    });
    this.result_Dependencia.data = [
      { Id: '1', Nombre: 'MUNICIPAL' },
      { Id: '2', Nombre: 'PAGADO' },
      { Id: '3', Nombre: 'SUBVENCIONADO' },
      { Id: '4', Nombre: 'CORP. ADMINISTRACION DELEGADA' },
    ]

    var user = this.auths.GetUserToken();
    if (user !== null) {

      this.EducacionSubcribe = this.faseService.fase$.subscribe(
        value => {
          if (value == '2') {
            this.contactservice.GetContactFull(user.primarysid, this.IdProceso).subscribe(
              (data: Contact) => {
                this.PerfilForm.controls['IdContacto'].setValue(data.IdContacto);
                //Boolean
                this.PerfilForm.controls['DeseaRecibirAsesoria'].setValue(data.DeseaRecibirAsesoria);
                this.PerfilForm.controls['EnsenhazaMediaEextranjero'].setValue(data.EnsenhazaMediaEextranjero);
                this.PerfilForm.controls['PrimeroMedioExterior'].setValue(data.PrimeroMedioExterior);
                this.PerfilForm.controls['SegundoMedioExterior'].setValue(data.SegundoMedioExterior);
                this.PerfilForm.controls['TerceroMedioExterior'].setValue(data.TerceroMedioExterior);
                this.PerfilForm.controls['CuartoMedioExterior'].setValue(data.CuartoMedioExterior);
                this.PerfilForm.controls['CursoEM2x1'].setValue(data.CursoEM2x1);
                this.PerfilForm.controls['BloqueoFinanciero'].setValue(data.BloqueoFinanciero);
                this.PerfilForm.controls['CurseEnsenhanzaModalidad'].setValue(data.CurseEnsenhanzaModalidad); // NO SE USA
                this.PerfilForm.controls['CuarsandoCuartoMedio'].setValue(data.CuarsandoCuartoMedio); // NO SE USA
                this.PerfilForm.controls['PrimeroMedio2x1'].setValue(data.PrimeroMedio2x1);
                this.PerfilForm.controls['SegundoMedio2x1'].setValue(data.SegundoMedio2x1);
                this.PerfilForm.controls['TerceroMedio2x1'].setValue(data.TerceroMedio2x1);
                this.PerfilForm.controls['CuartoMedio2x1'].setValue(data.CuartoMedio2x1);
                this.PerfilForm.controls['CertificadoCulminacionEM'].setValue(data.CertificadoCulminacionEM);
                this.CursandoCuartoMedio.emit(data.CuarsandoCuartoMedio);
                this.habilitaBotones = true;
                if (Number.parseInt(this.faseActual) < this.ultimafase) {
                  this.habilitaBotones = false;
                  this.Fase.emit('3')
                  this.faseService.fase$.emit('3');
                }


                this.mantenedor.getAnhoEgreso().pipe(
                  map(data => data.Result.filter(x => x.Value <= new Date().getFullYear()))
                ).subscribe(

                  (datae: any) => {
                    this.AnhosEgresos = datae;
                    this.AnhoPsu = datae.filter(x => x.Value == 2019);
                    if (data.AnhoEgresoEM !== null) {
                      this.PerfilForm.controls['AnhoEgresoEM'].setValue(data.AnhoEgresoEM.Value);
                    }
                    this.cargaAnhoEgreso = true;
                    this.validaDatosCargados();
                  },
                  (err) => {
                    this.validaDatosCargados();
                  }
                );


                this.mantenedor.getRegion().subscribe(
                  (datax: any) => {
                    this.RegionesColegios = datax.Result;
                    if (data.RegionEstudio !== null) {
                      this.PerfilForm.controls["RegionEstudio"].setValue(data.RegionEstudio.Id);
                      this.mantenedor.getestablecimientoeducacionl(data.RegionEstudio.Id).subscribe(
                        (datae: any) => {
                          this.Establecimientos = datae.Result;
                          this.Establecimientos2 = datae.Result;
                          this.PerfilForm.controls["EstablecimientoEducacionl"].setValue(data.EstablecimientoEducacionl?.Id);
                          const eSelect = this.Establecimientos2.filter(x => x.Id == data.EstablecimientoEducacionl?.Id);
                          if (eSelect.length > 0)
                            this.PerfilForm.controls.TipoDependencia.setValue(eSelect[0].Nombre2);

                          this.cargaDatosEstablecimiento = true;
                          this.validaDatosCargados();
                        },
                        error => { console.log('Error: ', error); }
                      );
                    } else {
                      this.cargaDatosEstablecimiento = true;
                      this.validaDatosCargados();
                    }
                    this.cargaDatosRegion = true;
                    this.validaDatosCargados();
                  },
                  (err) => {
                    // This is intentional
                  },
                  () => {
                    // This is intentional
                  }
                );
                this.changeCertLem();
                this.cargaDatosContacto = true
                this.validaDatosCargados();
              },
              (err) => { console.log(err) }
            );
            this.notaservice.GetNotas(user.primarysid).subscribe(
              (dato: Notas) => {
                this.PerfilForm.controls.PuntajePromedioPsu.setValue(dato.PuntajePromedioPsu);
                this.PerfilForm.controls.Ranking.setValue(dato.Ranking);
                this.PerfilForm.controls.AnhoPsu.setValue(dato.AnhoPsu);

                if (Number.parseInt(this.PerfilForm.controls.PuntajePromedioPsu.value) > 0) {
                  this.PerfilForm.controls.PuntajePromedioPsu.disable();
                } else {
                  this.PerfilForm.controls.PuntajePromedioPsu.enable();
                }

                if (Number.parseInt(this.PerfilForm.controls.Ranking.value) > 0) {
                  this.PerfilForm.controls.Ranking.disable();
                } else {
                  this.PerfilForm.controls.Ranking.enable();
                }

                if (Number.parseInt(this.PerfilForm.controls.AnhoPsu.value) > 0) {
                  this.PerfilForm.controls.AnhoPsu.disable();
                } else {
                  this.PerfilForm.controls.AnhoPsu.enable();
                }
                this.cargaDatosNotas = true;
                this.validaDatosCargados();
              },
              (err) => {
                // This is intentional
              }

            );
            this.notaservice.GetPSU(user.primarysid).subscribe(
              (dato: Notas) => {
                this.PerfilForm.controls.NotaPrimeroMedio.setValue(dato.NotaPrimeroMedio);
                this.PerfilForm.controls.NotaSegundoMedio.setValue(dato.NotaSegundoMedio);
                this.PerfilForm.controls.NotaTerceroMedio.setValue(dato.NotaTerceroMedio);
                this.PerfilForm.controls.NotaCuartoMedio.setValue(dato.NotaCuartoMedio);


                if (Number.parseInt(this.PerfilForm.controls.NotaPrimeroMedio.value) > 0) {
                  this.PerfilForm.controls.NotaPrimeroMedio.disable();
                } else {
                  this.PerfilForm.controls.NotaPrimeroMedio.enable();
                }
                if (Number.parseInt(this.PerfilForm.controls.NotaSegundoMedio.value) > 0) {
                  this.PerfilForm.controls.NotaSegundoMedio.disable();
                } else {
                  this.PerfilForm.controls.NotaSegundoMedio.enable();
                }
                if (Number.parseInt(this.PerfilForm.controls.NotaTerceroMedio.value) > 0) {
                  this.PerfilForm.controls.NotaTerceroMedio.disable();
                } else {
                  this.PerfilForm.controls.NotaTerceroMedio.enable();
                }
                if (Number.parseInt(this.PerfilForm.controls.NotaCuartoMedio.value) > 0) {
                  this.PerfilForm.controls.NotaCuartoMedio.disable();
                } else {
                  this.PerfilForm.controls.NotaCuartoMedio.enable();
                }
                this.cargaDatosNotasPsu = true;
                this.validaDatosCargados();
              },
              (err) => {
                // This is intentional
              }
            );

          }

        }
      );

    }

  }

  ngOnDestroy(): void {
    this.EducacionSubcribe.unsubscribe();
  }

  ngOnInit(): void {
    // This is intentional
  }

  validaDatosCargados() {
    if (this.cargaDatosContacto && this.cargaDatosRegion && this.cargaAnhoEgreso
      && this.cargaDatosEstablecimiento && this.cargaDatosNotasPsu && this.cargaDatosNotas) {
      this.cargandoDatos = false;
    }
  }
  changeEstoyEstudiandoCuartoMedio() {
    if (this.PerfilForm.controls.CuarsandoCuartoMedio.value) {
      this.PerfilForm.controls.RegionEstudio.setValidators([Validators.required]);
      this.PerfilForm.controls.EstablecimientoEducacionl.setValidators([Validators.required]);
      this.PerfilForm.controls.RegionEstudio.updateValueAndValidity();
      this.PerfilForm.controls.EstablecimientoEducacionl.updateValueAndValidity();
    } else {
      this.PerfilForm.controls.RegionEstudio.clearValidators();
      this.PerfilForm.controls.EstablecimientoEducacionl.clearValidators();
      this.PerfilForm.controls.RegionEstudio.updateValueAndValidity();
      this.PerfilForm.controls.EstablecimientoEducacionl.updateValueAndValidity();
    }
  }
  changeCertLem() {
    this.changeEstoyEstudiandoCuartoMedio();
    if (this.PerfilForm.controls.CuarsandoCuartoMedio.value) {
      this.PerfilForm.controls.AnhoEgresoEM.setValue('2020');
    }
    else {
      this.PerfilForm.controls.AnhoEgresoEM.setValue('');
    }
    if (this.PerfilForm.controls.CertificadoCulminacionEM.value && !this.PerfilForm.controls.EnsenhazaMediaEextranjero.value && !this.PerfilForm.controls.CuarsandoCuartoMedio.value) {
      this.PerfilForm.controls.RegionEstudio.setValidators([Validators.required]);
      this.PerfilForm.controls.EstablecimientoEducacionl.setValidators([Validators.required]);
      this.PerfilForm.controls.NotaPrimeroMedio.setValidators([Validators.required, Validators.min(1)]);
      this.PerfilForm.controls.NotaSegundoMedio.setValidators([Validators.required, Validators.min(1)]);
      this.PerfilForm.controls.NotaTerceroMedio.setValidators([Validators.required, Validators.min(1)]);
      this.PerfilForm.controls.NotaCuartoMedio.setValidators([Validators.required, Validators.min(1)]);
      this.PerfilForm.controls.RegionEstudio.updateValueAndValidity();
      this.PerfilForm.controls.EstablecimientoEducacionl.updateValueAndValidity();
      this.PerfilForm.controls.NotaPrimeroMedio.updateValueAndValidity();
      this.PerfilForm.controls.NotaSegundoMedio.updateValueAndValidity();
      this.PerfilForm.controls.NotaTerceroMedio.updateValueAndValidity();
      this.PerfilForm.controls.NotaCuartoMedio.updateValueAndValidity();
      this.PerfilForm.controls.AnhoEgresoEM.setValidators([Validators.required]);
      this.PerfilForm.controls.AnhoEgresoEM.updateValueAndValidity();
    } else {
      this.PerfilForm.controls.NotaPrimeroMedio.clearValidators();
      this.PerfilForm.controls.NotaSegundoMedio.clearValidators();
      this.PerfilForm.controls.NotaTerceroMedio.clearValidators();
      this.PerfilForm.controls.NotaCuartoMedio.clearValidators();
      this.PerfilForm.controls.RegionEstudio.updateValueAndValidity();
      this.PerfilForm.controls.EstablecimientoEducacionl.updateValueAndValidity();
      this.PerfilForm.controls.NotaPrimeroMedio.updateValueAndValidity();
      this.PerfilForm.controls.NotaSegundoMedio.updateValueAndValidity();
      this.PerfilForm.controls.NotaTerceroMedio.updateValueAndValidity();
      this.PerfilForm.controls.NotaCuartoMedio.updateValueAndValidity();
      this.PerfilForm.controls.AnhoEgresoEM.clearValidators();
      this.PerfilForm.controls.AnhoEgresoEM.updateValueAndValidity();

    }
    this.ChangeEMedia()
  }
  ChangeEMedia() {
    if (!this.PerfilForm.controls.CuarsandoCuartoMedio.value) {
      this.PerfilForm.controls.PrimeroMedioExterior.setValue(false);
      this.PerfilForm.controls.SegundoMedioExterior.setValue(false);
      this.PerfilForm.controls.TerceroMedioExterior.setValue(false);
      this.PerfilForm.controls.CuartoMedioExterior.setValue(false);
    }
  }
  ChangeRegionColegio(event: any) {
    const id = event.target.value;
    if (id === '') { return; }
    this.mantenedor.getestablecimientoeducacionl(id).subscribe(
      (data: any) => {
        this.Establecimientos = data.Result;
        this.Establecimientos2 = data.Result;
      },
      error => { console.log('Error: ', error); }
    );
  }

  ChangeNota1(event: any) {
    const value = event.target.value;
    if (value < 4 || value > 7) {
      this.PerfilForm.controls.NotaPrimeroMedio.setValue(null);
      this.PerfilForm.controls.NotaPrimeroMedio.updateValueAndValidity();
    }
  }
  ChangeNota2(event: any) {
    const value = event.target.value;
    if (value < 4 || value > 7) {
      this.PerfilForm.controls.NotaSegundoMedio.setValue(null);
      this.PerfilForm.controls.NotaSegundoMedio.updateValueAndValidity();
    }

  }
  ChangeNota3(event: any) {
    const value = event.target.value;
    if (value < 4 || value > 7) {
      this.PerfilForm.controls.NotaTerceroMedio.setValue(null);
      this.PerfilForm.controls.NotaTerceroMedio.updateValueAndValidity();
    }
  }
  ChangeNota4(event: any) {
    const value = event.target.value;
    if (value < 4 || value > 7) {
      this.PerfilForm.controls.NotaCuartoMedio.setValue(null);
      this.PerfilForm.controls.NotaCuartoMedio.updateValueAndValidity();
    }
  }

  ChangePromedioPsu(event: any) {
    const value = event.target.value;
    if (value < 1 || value > 850) {
      this.PerfilForm.controls.PuntajePromedioPsu.setValue(null);
      this.PerfilForm.controls.PuntajePromedioPsu.updateValueAndValidity();
    }
  }
  ChangeRanking(event: any) {
    const value = event.target.value;
    if (value < 1 || value > 850) {
      this.PerfilForm.controls.Ranking.setValue(null);
      this.PerfilForm.controls.Ranking.updateValueAndValidity();
    }
  }
  ChangeAnhoPsu(event: any) {
    const value = event.target.value;
    if (value < 2015 || value > (new Date()).getFullYear()) {
      this.PerfilForm.controls.AnhoPsu.setValue(null);
      this.PerfilForm.controls.AnhoPsu.updateValueAndValidity();
    }
    if (this.PerfilForm.controls.AnhoPsu.value != null) {
      this.PerfilForm.controls.AnhoPsu.disable();
    } else {
      this.PerfilForm.controls.AnhoPsu.enable();
    }
  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  keyPressFilterEstab(event: any) {
    this.Establecimientos = this.Establecimientos2.filter(x => x.Nombre.toUpperCase().includes(event.target.value.toUpperCase()))
  }
  changeEstablecimiento(event: any) {
    const eSelect = this.Establecimientos2.filter(x => x.Id == event.value);
    this.PerfilForm.controls.TipoDependencia.setValue(eSelect[0].Nombre2);
  }
  ValidaIngresaNotasExtranjero() {
    if (this.PerfilForm.controls.EnsenhazaMediaEextranjero.value) {
      this.PerfilForm.controls.PrimeroMedioExterior.setValidators([Validators.required, Validators.requiredTrue]);
      this.PerfilForm.controls.SegundoMedioExterior.setValidators([Validators.required, Validators.requiredTrue]);
      this.PerfilForm.controls.TerceroMedioExterior.setValidators([Validators.required, Validators.requiredTrue]);
      this.PerfilForm.controls.CuartoMedioExterior.setValidators([Validators.required, Validators.requiredTrue]);
      this.PerfilForm.controls.PrimeroMedioExterior.updateValueAndValidity();
      this.PerfilForm.controls.SegundoMedioExterior.updateValueAndValidity();
      this.PerfilForm.controls.TerceroMedioExterior.updateValueAndValidity();
      this.PerfilForm.controls.CuartoMedioExterior.updateValueAndValidity();


      if (this.PerfilForm.controls.PrimeroMedioExterior.value == true
        || this.PerfilForm.controls.SegundoMedioExterior.value == true
        || this.PerfilForm.controls.TerceroMedioExterior.value == true
        || this.PerfilForm.controls.CuartoMedioExterior.value == true) {
        this.PerfilForm.controls.PrimeroMedioExterior.clearValidators();
        this.PerfilForm.controls.SegundoMedioExterior.clearValidators();
        this.PerfilForm.controls.TerceroMedioExterior.clearValidators();
        this.PerfilForm.controls.CuartoMedioExterior.clearValidators();
        this.PerfilForm.controls.PrimeroMedioExterior.updateValueAndValidity();
        this.PerfilForm.controls.SegundoMedioExterior.updateValueAndValidity();
        this.PerfilForm.controls.TerceroMedioExterior.updateValueAndValidity();
        this.PerfilForm.controls.CuartoMedioExterior.updateValueAndValidity();
      } else {
        this.alerts.info("Debe seleccionar al menos un curso en el extranjero.", "Información");
      }
    } else {
      this.PerfilForm.controls.PrimeroMedioExterior.clearValidators();
      this.PerfilForm.controls.SegundoMedioExterior.clearValidators();
      this.PerfilForm.controls.TerceroMedioExterior.clearValidators();
      this.PerfilForm.controls.CuartoMedioExterior.clearValidators();
      this.PerfilForm.controls.PrimeroMedioExterior.updateValueAndValidity();
      this.PerfilForm.controls.SegundoMedioExterior.updateValueAndValidity();
      this.PerfilForm.controls.TerceroMedioExterior.updateValueAndValidity();
      this.PerfilForm.controls.CuartoMedioExterior.updateValueAndValidity();
    }
  }

  ValidaIngresaCurso2x1() {
    if (this.PerfilForm.controls.CursoEM2x1.value) {
      this.PerfilForm.controls.PrimeroMedio2x1.setValidators([Validators.required, Validators.requiredTrue]);
      this.PerfilForm.controls.SegundoMedioExterior.setValidators([Validators.required, Validators.requiredTrue]);
      this.PerfilForm.controls.TerceroMedio2x1.setValidators([Validators.required, Validators.requiredTrue]);
      this.PerfilForm.controls.CuartoMedio2x1.setValidators([Validators.required, Validators.requiredTrue]);
      this.PerfilForm.controls.PrimeroMedio2x1.updateValueAndValidity();
      this.PerfilForm.controls.SegundoMedio2x1.updateValueAndValidity();
      this.PerfilForm.controls.TerceroMedio2x1.updateValueAndValidity();
      this.PerfilForm.controls.CuartoMedio2x1.updateValueAndValidity();


      if (this.PerfilForm.controls.PrimeroMedio2x1.value == true
        || this.PerfilForm.controls.SegundoMedio2x1.value == true
        || this.PerfilForm.controls.TerceroMedio2x1.value == true
        || this.PerfilForm.controls.CuartoMedio2x1.value == true) {
        this.PerfilForm.controls.PrimeroMedio2x1.clearValidators();
        this.PerfilForm.controls.SegundoMedio2x1.clearValidators();
        this.PerfilForm.controls.TerceroMedio2x1.clearValidators();
        this.PerfilForm.controls.CuartoMedio2x1.clearValidators();
        this.PerfilForm.controls.PrimeroMedio2x1.updateValueAndValidity();
        this.PerfilForm.controls.SegundoMedio2x1.updateValueAndValidity();
        this.PerfilForm.controls.TerceroMedio2x1.updateValueAndValidity();
        this.PerfilForm.controls.CuartoMedio2x1.updateValueAndValidity();
      } else {
        this.alerts.info("Debe seleccionar al menos un curso 2x1.", "Información");
      }
    } else {
      this.PerfilForm.controls.PrimeroMedio2x1.clearValidators();
      this.PerfilForm.controls.SegundoMedio2x1.clearValidators();
      this.PerfilForm.controls.TerceroMedio2x1.clearValidators();
      this.PerfilForm.controls.CuartoMedio2x1.clearValidators();
      this.PerfilForm.controls.PrimeroMedio2x1.updateValueAndValidity();
      this.PerfilForm.controls.SegundoMedio2x1.updateValueAndValidity();
      this.PerfilForm.controls.TerceroMedio2x1.updateValueAndValidity();
      this.PerfilForm.controls.CuartoMedio2x1.updateValueAndValidity();
    }
  }

  Guardar() {
    this.ValidaIngresaCurso2x1();
    this.ValidaIngresaNotasExtranjero();
    this.validateAllFormFields(this.PerfilForm);
    if (this.PerfilForm.valid) {
      this.progress = true;
      //nota
      this.PerfilForm.controls.NotaPrimeroMedio.enable();
      this.PerfilForm.controls.NotaSegundoMedio.enable();
      this.PerfilForm.controls.NotaTerceroMedio.enable();
      this.PerfilForm.controls.NotaCuartoMedio.enable();
      const nota = new Notas(this.PerfilForm.value);
      this.notaservice.CrearNotas(nota).subscribe(
        (data) => { console.log(data) },
        (err) => { console.log(err) },
        () => {
          // This is intentional
        },
      );
      //puntaje
      this.PerfilForm.controls.Ranking.enable();
      this.PerfilForm.controls.PuntajePromedioPsu.enable();
      this.PerfilForm.controls.AnhoPsu.enable();
      const psus = new Puntaje(this.PerfilForm.value);
      this.notaservice.CrearPSU(psus).subscribe(
        (data) => { console.log(data) },
        (err) => { console.log(err) },
        () => {
          // This is intentional
        },
      );
      this.PerfilForm.controls.NotaPrimeroMedio.disable();
      this.PerfilForm.controls.NotaSegundoMedio.disable();
      this.PerfilForm.controls.NotaTerceroMedio.disable();
      this.PerfilForm.controls.NotaCuartoMedio.disable();
      this.PerfilForm.controls.Ranking.disable();
      this.PerfilForm.controls.PuntajePromedioPsu.disable();
      this.PerfilForm.controls.AnhoPsu.disable();
      //Datos Acad Alumno
      console.log("Entra al método");
      var contacto = new Contact(this.PerfilForm.value);
      contacto.IdProceso = this.IdProceso;
      this.contactservice.UpdateContact(contacto).subscribe(
        (data) => {
          console.log("Correcto");
          this.alertSucces = true;
          setTimeout(() => {
            this.alertSucces = false;
            this.progress = false;
          }, 7000);
        },
        (err) => {
          console.log("error");
          this.alertError = true;
          setTimeout(() => {
            this.alertError = false;
            this.progress = false;

          }, 7000);
        },
        () => {
          this.progress = false;
        }
      );

    }
  }
  GuardarContinuar() {
    this.ValidaIngresaCurso2x1();
    this.ValidaIngresaNotasExtranjero();
    this.validateAllFormFields(this.PerfilForm);
    if (this.PerfilForm.valid) {
      this.CursandoCuartoMedio.emit(this.PerfilForm.controls.CuarsandoCuartoMedio.value);
      this.progress = true;
      console.log('ingreso al envio de la fase' + this.IdProceso);
      this.PerfilForm.controls.FasePortal.setValue('3');
      //nota
      this.PerfilForm.controls.NotaPrimeroMedio.enable();
      this.PerfilForm.controls.NotaSegundoMedio.enable();
      this.PerfilForm.controls.NotaTerceroMedio.enable();
      this.PerfilForm.controls.NotaCuartoMedio.enable();
      const nota = new Notas(this.PerfilForm.value);
      this.notaservice.CrearNotas(nota).subscribe(
        (data) => { console.log(data) },
        (err) => { console.log(err) }
      );
      //puntaje
      this.PerfilForm.controls.Ranking.enable();
      this.PerfilForm.controls.PuntajePromedioPsu.enable();
      this.PerfilForm.controls.AnhoPsu.enable();
      const psus = new Puntaje(this.PerfilForm.value);
      this.notaservice.CrearPSU(psus).subscribe(
        (data) => { console.log(data) },
        (err) => { console.log(err) }
      );
      this.PerfilForm.controls.NotaPrimeroMedio.disable();
      this.PerfilForm.controls.NotaSegundoMedio.disable();
      this.PerfilForm.controls.NotaTerceroMedio.disable();
      this.PerfilForm.controls.NotaCuartoMedio.disable();
      this.PerfilForm.controls.Ranking.disable();
      this.PerfilForm.controls.PuntajePromedioPsu.disable();
      this.PerfilForm.controls.AnhoPsu.disable();
      //Update el proceso 
      this.procesoservice.setFase(this.IdProceso, '3').subscribe(
        (data) => {
          console.log(data);
          this.progress = false;
          this.Fase.emit('3');
          this.faseService.fase$.emit('3');
        },
        (err) => { console.log(err) }
      );

      //Datos Acad Alumno
      console.log("Entra al método");
      var contacto = new Contact(this.PerfilForm.value);
      contacto.IdProceso = this.IdProceso;
      this.contactservice.UpdateContact(contacto).subscribe(
        (data) => {
          console.log("Correcto");
          this.alertSucces = true;
          setTimeout(() => {
            this.alertSucces = false;
            this.progress = false;
          }, 7000);
        },
        (err) => {
          console.log("error");
          this.alertError = true;
          setTimeout(() => {
            this.alertError = false;
            this.progress = false;

          }, 7000);
        },
        () => {
          this.progress = false;
        }
      );
    }

  }


}
